import { Club } from "../types/types";
import { fetchGet, fetchPost } from "../util/apiUtil";

export const loadClubdetails = (shortName: string) =>
  fetchGet("Club/GetByShortName", shortName);

export const updateClubdetails = (club: Club) => fetchPost("Club/Update", club);

export const createClub = (club: Club) => fetchPost("Club/Create", club);
